export type State =
  | { difficulty: 1 }
  // | { difficulty: 2 }
  | { difficulty: 3 }

export type Action =
  | "difficulty-1"
  // | "difficulty-2"
  | "difficulty-3"

export const INITIAL_STATE: State = { difficulty: 1 };

export function GameDifficultyReducer(state: State, action: Action): State {
  switch (action) {
    case "difficulty-1": return { difficulty: 1 };
    // case "difficulty-2": return { difficulty: 2 };
    case "difficulty-3": return { difficulty: 3 };
  }
  return state;
}
